import React from "react";
import {
  ErrorBoundary as ReactErrorBoundary,
  ErrorBoundaryProps,
} from "react-error-boundary";

import { reportError } from "lib/Datadog";

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  ...props
}) => (
  <ReactErrorBoundary
    {...props}
    onError={({ message, ...report }, info) => {
      reportError({ message, ...report });
      props.onError && props.onError({ message, ...report }, info);
    }}
  >
    <>{children}</>
  </ReactErrorBoundary>
);

export default ErrorBoundary;
